
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/freeze-dried-raw-beef",
      function () {
        return require("private-next-pages/recipes/freeze-dried-raw-beef.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipes/freeze-dried-raw-beef"])
      });
    }
  